import styled from 'styled-components/native';
import Image from '~/components/Image';

export const CONTAINER_WIDTH = 600;

// Reserves vertical space for the modal's own padding, close button, and
// pagination dots so a fitted image never needs the page to scroll.
export const MODAL_CHROME_HEIGHT = 220;

// Floor so a very short browser window never yields a negative bound.
export const MIN_IMAGE_HEIGHT = 200;

export const Content = styled.View`
  align-items: center;
`;

export const CarouselContainer = styled.View`
  width: ${CONTAINER_WIDTH}px;
`;

export const FullImageContainer = styled.View<{ maxHeight: number }>`
  width: ${CONTAINER_WIDTH}px;
  max-height: ${({ maxHeight }) => maxHeight}px;
  justify-content: center;
  align-items: center;
`;

export const FullImage = styled(Image).attrs({
  fitWidth: CONTAINER_WIDTH,
  contentFit: 'contain',
})`
  border-radius: 14px;
  background-color: ${({ theme }) => theme.color.base.c1};
`;

export const PaginationContainer = styled.View`
  align-items: center;
  padding-top: 24px;
  padding-bottom: 8px;
`;
